import React from "react";

const New_Lines = () => {
  return (
    <div>
      <h1>New_Lines Component</h1>
      <p>Content for New_Lines goes here...</p>
    </div>
  );
};

export default New_Lines;
